import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { NextSeo } from "next-seo";

import Header from "../../Header";
import Footer from "../../Footer";
import SideMenu from "../../SideMenu";
import { NavigationBar } from "../../../src/components/atoms";
import { useRouter } from "next/router";
import { Constants, Values } from "../../../src/config";
import slugify from "slugify";
import { uniqBy } from "lodash";
import { getClass } from "../../../src/helpers/formatHelpers";

const GuideState = (props) => {
  const { t } = useTranslation();

  const {
    categoryType,
    listDataCountry,
    listDataState,
    listDataCity,
    listData,
    continentSelected,
    countrySelected,
    stateSelected,
  } = props;
  const router = useRouter();
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [isMobileVersion, setIsMobileVersion] = useState(false);
  const countries = listDataCountry;
  const states = listDataState;
  const cities = listDataCity;
  const types = listData;
  const stateData = states?.find(
    (i) =>
      slugify(i.stateName?.toLowerCase()) ===
      stateSelected?.replace("-state", "")
  );
  const metaTitle = `${stateData?.stateName}`;
  const metaDescription = `Discover ${
    process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
      ? "clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
      ? "rooftops"
      : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
      ? "cocktail bars"
      : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
      ? "spas"
      : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
      ? "beach clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
      ? "prefab homes manufacturers"
      : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
      ? "zoos & animal parks"
      : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
      ? "amusement parks"
      : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
      ? "casinos"
      : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
      ? "castles"
      : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
      ? "luxury resorts"
      : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
      ? "aparthotels"
      : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
      ? "festivals"
      : "clubs"
  } in ${stateData?.stateName} with our guides.`;

  useEffect(() => {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  return (
    <div>
      <NextSeo
        noindex={false}
        nofollow={false}
        title={`${metaTitle} Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        description={metaDescription}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${continentSelected}/${countrySelected}/${stateSelected}`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${continentSelected}/${countrySelected}/${stateSelected}`,
          title: `${metaTitle} Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: metaDescription,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className={`${getClass("background", true)}`}>
        <div
          className={`mx-auto relative ${
            isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]"
          } pb-[130px]`}>
          <div className="max-w-1160px min-h-screen flex-1 mx-auto">
            <NavigationBar
              title={metaTitle}
              customStyle={{ marginTop: 0 }}
              isMobileVersion={isMobileVersion}
              onBackPressed={() =>
                router.push(`/guides/${continentSelected}/${countrySelected}`)
              }
            />
            <div className="flex flex-row flex-wrap items-center px-[20px]">
              {uniqBy(types, "filterId")
                ?.sort((a, b) => a?.filterOrder - b?.filterOrder)
                ?.map((item, index) => (
                  <Link
                    href={`/guides/${continentSelected}/${countrySelected}/${stateSelected}/${
                      item?.filterName === "All"
                        ? process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
                          ? "clubs"
                          : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
                          ? "rooftops"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
                          ? "cocktail-bars"
                          : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
                          ? "spas"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
                          ? "beach-clubs"
                          : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
                          ? "prefab-homes-manufacturers"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
                          ? "all"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
                          ? "all"
                          : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
                          ? "all"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
                          ? "all"
                          : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
                          ? "all"
                          : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
                          ? "all"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
                          ? "festivals"
                          : "clubs"
                        : (process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
                          process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
                          process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
                          process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
                          process.env.NEXT_PUBLIC_APP_NAME ==
                            "LuxResort Club" ||
                          process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
                            ? item?.filterName !== "All" &&
                              item?.filterName !== "Aviary" &&
                              item?.filterName !== "Animal sanctuary" &&
                              item?.filterName !== "Basic" &&
                              item?.filterName !== "Premium" &&
                              item?.filterName !== "Luxury" &&
                              item?.filterName !== "Best"
                              ? slugify(item?.filterName?.toLowerCase()) + "s"
                              : slugify(
                                  item?.filterName
                                    ?.replace("Aviary", "Aviaries")
                                    ?.replace(
                                      "Animal sanctuary",
                                      "Animal sanctuaries"
                                    )
                                    ?.toLowerCase()
                                )
                            : item?.filterName !== "Pool" &&
                              item?.filterName !== "Bar" &&
                              item?.filterName !== "Restaurant"
                            ? slugify(
                                item?.filterName
                                  ?.replace(" Spa", "")
                                  ?.toLowerCase()
                              ) + "-"
                            : "") +
                          `${
                            process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
                              ? "clubs"
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "RooftopClub"
                              ? item?.filterName === "Pool" ||
                                item?.filterName === "Bar" ||
                                item?.filterName === "Restaurant"
                                ? "rooftop"
                                : "rooftops"
                              : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
                              ? "cocktail-bars"
                              : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
                              ? "spas"
                              : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
                              ? "beach-clubs"
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "PrefabWorld"
                              ? "prefab-homes-manufacturers"
                              : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
                              ? ""
                              : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
                              ? ""
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "WorldCasino"
                              ? ""
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "Castlepedia"
                              ? ""
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "LuxResort Club"
                              ? ""
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "AparthotelClub"
                              ? ""
                              : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
                              ? "festivals"
                              : "clubs"
                          }${
                            item &&
                            (item?.filterName === "Pool" ||
                              item?.filterName === "Bar" ||
                              item?.filterName === "Restaurant")
                              ? "-" +
                                slugify(item?.filterName?.toLowerCase() + "s")
                              : ""
                          }`
                    }`}>
                    <a
                      className={`flex flex-col justify-center items-center border ${getClass(
                        "border-black",
                        true
                      )} px-[10px] py-[5px] rounded-full ${getClass(
                        "text-white",
                        true
                      )} uppercase font-regular text-base text-center ${
                        isMobileVersion
                          ? "mb-[12px] mr-[12px]"
                          : "mb-[30px] mr-[30px]"
                      }`}
                      key={index}>
                      <div>{item?.filterName}</div>
                    </a>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GuideState;
